<ng-container *ngIf="pageData && !isServerError">
<mat-table [dataSource]="updatedDataSource" class="recently-accepted-table">
  <ng-container matColumnDef="courseName">
    <mat-cell *matCellDef="let element" class="assignment-text-td phone-tablet-td">
      <div class="phone-tablet-content">
        <div class="d-flex align-items-flex-start justify-content-space-between mb-1">
          {{ element.courseName }}

          <ng-container *ngIf="element.moreOptions">
            <app-dropdown align="end" panelClass="table-dropdown" [width]="170">
              <button app-dropdown-trigger class="no-style table-menu">
                <mat-icon [svgIcon]="'dots'" class="table-menu-icon"></mat-icon>
              </button>
              <ng-container app-dropdown-content>
                <ng-container *ngFor="let listItem of getFilteredStudentDataTypes(element.dataType)">
                <div class="dropdown-list" >
                  <a class="dropdown-item" *ngFor="let item of listItem.links" [href]="item.url">{{item.name}}</a>
                </div>
              </ng-container>
              </ng-container>
            </app-dropdown>
          </ng-container>
        </div>
        <div class="d-flex align-items-center justify-content-space-between">
          <div class="d-flex align-items-center">
            <div
              class="state"
              [ngClass]="getDynamicClassName(element.studentDataType)"
            >
              {{ element.informationName }}
            </div>

            <div class="date">{{ element.timeDetails }}</div>
          </div>

          <div *ngIf="element.finalScore" class="badge"> {{generalSettingsData.finalGrade}} </div>
          <div class="rating-number">{{ element.grade }}</div>
        </div>

        <div *ngIf="element.dataDisplay" class="view-grades-link">
          <a href="#">  {{generalSettingsData.viewingGrades}}</a>
        </div>
      </div>

      <div class="desktop-content">
        {{ element.courseName }}
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="informationName">
    <mat-cell *matCellDef="let element" class="desktop-td">
      <div
        class="state"
        [ngClass]="getDynamicClassName(element.studentDataType)"
      >
        {{ element.informationName }}
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="timeDetails">
    <mat-cell *matCellDef="let element" class="desktop-td">
      <div class="date">{{ element.timeDetails}}</div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="grade">
    <mat-cell *matCellDef="let element" class="desktop-td">
      <div class="rating-number">{{ element.grade }}</div>
      <div *ngIf="element.finalScore" class="badge mr-1"> {{generalSettingsData.finalGrade}}</div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="moreOptions">
    <mat-cell *matCellDef="let element" class="desktop-td actions-td">
      <a *ngIf="element.dataDisplay" href="#">{{generalSettingsData.viewingGrades}} </a>

      <ng-container *ngIf="element.moreOptions">
        <app-dropdown align="end" panelClass="table-dropdown" [width]="170">
          <button app-dropdown-trigger class="no-style table-menu">
            <mat-icon [svgIcon]="'dots'" class="table-menu-icon"></mat-icon>
          </button>
          <ng-container app-dropdown-content>
            <ng-container *ngFor="let listItem of getFilteredStudentDataTypes(element.dataType)">
              <div class="dropdown-list" >
                <a class="dropdown-item" *ngFor="let item of listItem.links" [href]="item.url">{{item.name}}</a>
              </div>
            </ng-container>
          </ng-container>
        </app-dropdown>
      </ng-container>
    </mat-cell>
  </ng-container>

  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>

<ng-container *ngIf="isLoading">
  <app-skeleton  *ngFor="let _ of [].constructor(pageData.pageSize)"  class="item-skeleton" [height]="60"></app-skeleton>
</ng-container>

<div class="text-center" *ngIf="currentPage < pageData.totalPages">
  <button class="no-style show-more-btn" [disabled]="isLoading" (click)="loadMoreData()">
    {{generalSettingsData?.showMoreText}}
    <mat-icon [svgIcon]="'show-more'" class="square-icon show-more-icon"></mat-icon>
  </button>
</div>
</ng-container>

<app-timeout-error-message *ngIf="isServerError"></app-timeout-error-message>